/*
 *   File : tab.js
 *   Author URI : https://evoqins.com
 *   Description : Tab component
 *   Integrations :NA
 *   Version : v1.0
 */

// custom packages
import React from "react";

// custom style
import custom_style from "../../Style/Components/others.module.scss";

const CustomTab = (props) => {
  return (
    <div
      className={`${custom_style.e_tab_wrapper} ${
        props.tabIndex === props.tabData.id ? "pe-none" : ""
      } w-max-content`}
      onClick={() => props.handleChange(props.tabData.id)}
    >
      <div
        className={` w-max-content e-text-eerie-black e-font-16 pb-3 ${custom_style.e_tab}
            ${
              props.tabIndex === props.tabData.id
                ? `${
                    custom_style.e_active_tab
                  } w-max-content e-cursor-pointer e-font-weight-600 e-font-16  e-primary-font-poppins  pe-none 
                           ${
                             props.type === 2
                               ? `
                            ${
                              props.className
                                ? props.className
                                : "py-1 me-2 e-font-16"
                            }
                             `
                               : `${
                                   props.borderRadius
                                     ? props.borderRadius
                                     : "border-radius-12 "
                                 } py-1 me-2 line-height-20px e-font-16    `
                           }`
                : `${custom_style.e_inactive_tab} 
                            ${
                              props.type === 2
                                ? `
                             e-text-dark-gray e-cursor-pointer
                            ${
                              props.className
                                ? props.className
                                : "border-radius-8 py-1 px-2 me-2 e-font-14 line-height-16px"
                            }
                            ${
                              props.background
                                ? props.background
                                : "e-bg-soft-violet"
                            }
                            `
                                : "py-1 px-2 line-height-20px me-2 e-cursor-pointer e-font-16 e-text-eerie-black"
                            }`
            }
            
          `}
      >
        {props.tabData.label}
      </div>
    </div>
  );
};

export default CustomTab;
